import { apiSlice } from '@/store/api/apiSlice';

export interface WeeklyPredictionResponse {
  prediction: string;
}

export interface WeeklyPredictionArgs {
  rashi: string;
}

export const weeklyPredictionApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWeeklyPrediction: builder.query<WeeklyPredictionResponse, WeeklyPredictionArgs>({
      query: ({ rashi }) => ({
        url: 'predictions/weekly',
        method: 'GET',
        params: {
          rashi,
        },
      }),
    }),
  }),
});

export const { useGetWeeklyPredictionQuery, useLazyGetWeeklyPredictionQuery } = weeklyPredictionApi;
